module.exports = __webpack_public_path__ + "static/media/honeydew.c02b3e0c.png";